import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_3 = { class: "shortcut" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Shortcuts", -1)
const _hoisted_5 = { class: "col half shortcut-list" }

import { computed, markRaw } from "vue";
import { useStore } from "vuex";
import { Shortcut } from "@/models/shortcut";
import { Actions } from "@/store";
import ShortcutKey from "./ShortcutKey.vue";
import { DrawerMutations } from "@/stores/drawer.store";
import ShortcutForm from "../shortcut/ShortcutForm.vue";
import Filter from "../common/Filter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Shortcuts',
  setup(__props) {

const store = useStore();
const shortcuts = computed<Shortcut[]>(() =>
  [...store.getters.filteredShortcuts].sort((a, b) =>
    a.name > b.name ? 1 : -1
  )
);

const addShortcut = () => {
  store.dispatch(Actions.NewShortcut);
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(ShortcutForm),
    data: {
      drawer: true
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Filter),
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: addShortcut
      }, [
        _hoisted_2,
        _createTextVNode(" Add Shortcut ")
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shortcuts.value, (shortcut) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createVNode(ShortcutKey, { shortcut: shortcut }, null, 8, ["shortcut"])
          ]))
        }), 256))
      ])
    ])
  ], 64))
}
}

})